import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

function checkRole (user, roleName) {
  if (!user) return false
  let check = user.roles.find((role) => {
    if (typeof roleName === 'object') {
      return roleName.indexOf(role.name) !== -1
    } else {
      return role.name === roleName
    }
  })
  return !!check
}
function createModel (schema) {
  if (!schema) return []
  let ignoreField = [
    'objectId',
    'ACL',
    'createdAt',
    'updatedAt'
  ]
  let manager = []
  schema.forEach(s => {
    let fields = []
    for (let name in s.fields) {
      if (ignoreField.indexOf(name) > -1) continue
      fields.push({ name: name })
    }
    manager.push({
      className: s.className,
      fields: fields
    })
  })
  return manager
}
const store = new Vuex.Store({
  state: {
    openid: null,
    login: false,
    token: null,
    originToken: null,
    user: null,
    project: null,
    devModel: [],
    devMode: true,
    changelog: null,
    chatDrawer: false
  },
  getters: {
    isAdmin (state) {
      return checkRole(state.user, ['admin', 'master'])
    },
    isMaster (state) {
      return checkRole(state.user, 'master')
    },
    model (state) {
      if (!state.project) return []
      if (!checkRole(state.user, ['admin', 'master'])) return state.project.model
      return state.devMode ? state.devModel : state.project.model
    }
  },
  mutations: {
    initFromStorage (state, opt) {
      for (let i in opt) {
        state[i] = opt[i]
      }
    },
    login (state, data) {
      state.login = true
      state.token = data
      Vue.prototype.$apiAjax.config.headers = {
        Authorization: 'Bearer ' + data.token
      }
    },
    logout (state) {
      state.login = false
      state.token = null
      state.user = null
      Vue.prototype.$apiAjax.config.headers = {}
    },
    setOpenid (state, id) {
      state.openid = id
    },
    setUser (state, user) {
      state.user = user
    },
    setChangeLog (state, data) {
      state.changelog = data
    },
    setProject (state, project) {
      if (project && this.getters.isAdmin) {
        state.devModel = createModel(project.schema)
      }
      if (project && !project.model) {
        project.model = []
      }
      state.project = project
    },
    setProjectApiConfig (state, config) {
      state.project.api_config = config
    },
    setSchema (state, schema) {
      state.project.schema = schema
      if (this.getters.isAdmin) {
        state.devModel = createModel(state.project.schema)
      }
    },
    setModel (state, model) {
      state.project.model = model
    },
    setDevMode (state, mode) {
      state.devMode = mode
    },
    setChatDrawer (state, val) {
      state.chatDrawer = val
    },
  },
  actions: {
    async fakeLogin (context, id) {
      try {
        let rs = await Vue.prototype.$apiAjax.post('/fakeLogin', { id: id })
        context.state.originToken = context.state.token
        context.commit('login', rs.data)
        let user = await Vue.prototype.$apiAjax.getData('/user/me')
        context.commit('setUser', user)
        window.location.reload()
      } catch (e) {
        if (context.state.originToken) context.commit('login', context.state.originToken)
      }
    },
    async fakeLogout (context) {
      context.commit('login', context.state.originToken)
      let user = await Vue.prototype.$apiAjax.getData('/user/me')
      context.state.originToken = null
      context.commit('setUser', user)
      window.location.reload()
    }
  }
})
export default store
